import { FC } from "react";
import {
  StyledProgressBar,
  StyledSvg,
  StyledCircleBackground,
  StyledCircleProgress,
  CIRCUMFERENCE,
  VIEW_BOX_SIZE,
  CENTER,
  RADIUS,
} from "./circular-progress.style";
import { MDSCircularProgressProps } from "./circular-progress.types";

export const MDSCircularProgress: FC<MDSCircularProgressProps> = ({
  current,
  total,
  animated = false,
  minValue = 0,
  maxValue,
  ...props
}) => {
  const value = total === 0 ? 0 : Math.min(Math.max(current, minValue), maxValue ?? total);
  const calculatedMaxValue = maxValue ?? total;

  return (
    <StyledProgressBar value={value} minValue={minValue} maxValue={calculatedMaxValue} {...props}>
      {({ percentage }) => {
        const progressPercentage = percentage ?? 0;
        const strokeDashoffset = CIRCUMFERENCE - (progressPercentage / 100) * CIRCUMFERENCE;

        return (
          <StyledSvg viewBox={`0 0 ${VIEW_BOX_SIZE} ${VIEW_BOX_SIZE}`} aria-hidden="true">
            <StyledCircleBackground cx={CENTER} cy={CENTER} r={RADIUS} />
            <StyledCircleProgress
              cx={CENTER}
              cy={CENTER}
              r={RADIUS}
              strokeDasharray={CIRCUMFERENCE}
              animate={{
                strokeDashoffset,
              }}
              transition={
                animated
                  ? {
                      type: "spring",
                      stiffness: 100,
                      damping: 20,
                    }
                  : {
                      duration: 0,
                    }
              }
              $animated={animated}
            />
          </StyledSvg>
        );
      }}
    </StyledProgressBar>
  );
};
